import { format } from 'date-fns';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import { TaskEvent } from '~/atoms/schemas/workflowSchemas';

const formatTaskName = (name: string): string => {
  return name
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .replace(/^./, (str) => str.toUpperCase());
};

export const TaskEvents = ({ events }: { events: TaskEvent[] }) => {
  if (events.length === 0) return null;

  return (
    <div className="px-2 pb-2" style={{ borderTop: '1px solid #333' }}>
      <div className="text-base mt-2 mb-2 flex align-items-center">
        <i
          className="pi pi-history mr-1 text-sm pr-1"
          style={{ color: '#5caedc' }}
        />
        <span>Events:</span>
      </div>
      {events.map((event, eventIndex) => (
        <div
          key={event.event_id}
          className={eventIndex < events.length - 1 ? 'mb-2' : ''}
        >
          <div
            className="p-2 border-round"
            style={{
              backgroundColor: '#1e1e1e',
              color: 'white',
              borderLeft: `3px solid ${
                event.action === 'proceed'
                  ? '#4caf50'
                  : event.action === 'reject'
                    ? '#f44336'
                    : event.action === 'wait'
                      ? '#ff9800'
                      : '#5caedc'
              }`,
            }}
          >
            <div className="flex justify-content-between align-items-center mb-1">
              <span className="text-sm" style={{ color: '#5caedc' }}>
                <i className="pi pi-calendar-plus mr-1 text-sm" />
                {formatTaskName(event.type)}
              </span>
              <span className="text-xs bg-bluegray-800 px-2 py-1 border-round">
                <i className="pi pi-clock mr-1 text-xs" />
                {format(new Date(event.updated_at), 'MMM dd HH:mm:ss')}
              </span>
            </div>

            <div>
              {event.action && (
                <div className="flex align-items-center mb-1">
                  <span className="text-sm font-medium mr-1">Action:</span>
                  <span
                    className={`px-2 py-1 text-xs border-round ${
                      event.action === 'proceed'
                        ? 'bg-green-900 text-green-100'
                        : event.action === 'reject'
                          ? 'bg-red-900 text-red-100'
                          : event.action === 'wait'
                            ? 'bg-orange-900 text-orange-100'
                            : 'bg-bluegray-900 text-bluegray-100'
                    }`}
                  >
                    {event.action}
                  </span>
                </div>
              )}
              {event.explanation && (
                <div>
                  <div className="text-sm font-medium mb-1">Explanation:</div>
                  <div
                    className="p-2 border-round bg-bluegray-900 text-xs"
                    style={{ lineHeight: '1.4' }}
                  >
                    <Markdown
                      remarkPlugins={[remarkBreaks]}
                      components={{
                        ul: (props) => (
                          <ul style={{ paddingLeft: '1rem' }} {...props} />
                        ),
                      }}
                    >
                      {event.explanation}
                    </Markdown>
                  </div>
                </div>
              )}
              {event.type === 'AgentToolUsageEvent' && event.tool_name && (
                <div>
                  <div className="text-sm font-medium mb-1">Tool Name:</div>
                  <div
                    className="p-2 border-round bg-bluegray-900 text-xs"
                    style={{ lineHeight: '1.4' }}
                  >
                    {formatTaskName(event.tool_name)}
                  </div>
                </div>
              )}
            </div>
          </div>
          {eventIndex < events.length - 1 && (
            <div className="flex align-items-center justify-content-center my-1">
              <i className="pi pi-arrow-down text-bluegray-500 text-xs" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
